import { useFeature } from 'flagged';
import { ConfigFeatureFlags } from '../services/service-config-types';
var useDisputesLinkFeature = function (_a) {
    var accountFeatures = _a.accountFeatures;
    var isDisputesLinkEnabled = useFeature(ConfigFeatureFlags.disputesLink);
    return isDisputesLinkEnabled && Boolean(accountFeatures === null || accountFeatures === void 0 ? void 0 : accountFeatures.accessToDisputes);
};
export default useDisputesLinkFeature;
//# sourceMappingURL=use-disputes-link-feature.js.map